module.exports = __webpack_public_path__ + "static/media/UG_Syllabus_2021-22_EXTC_Sem_VII-VIII.851315cc.pdf";